import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SectionGaugeCard from '../ui/SectionGaugeCard'
import { formatNumber, formatPercent } from './utils'
import { VIEW_MODES } from './constants'

const EMPTY_TOOLTIP = 'Aucune note pour cette section'

const gaugeValueFor = (summary, viewMode, gradeMax) => {
  if (viewMode === VIEW_MODES.SATISFACTION)
    return Number.isFinite(summary.satisfaction_rate) ? summary.satisfaction_rate : null
  if (!Number.isFinite(summary.grade) || gradeMax <= 0)
    return null
  return summary.grade / gradeMax * 100
}

const valueParts = (summary, viewMode, gradeMax) => {
  if (viewMode === VIEW_MODES.SATISFACTION)
    return { main: formatPercent(summary.satisfaction_rate), suffix: null }
  if (!Number.isFinite(summary.grade))
    return { main: '--', suffix: null }
  return { main: formatNumber(summary.grade), suffix: `/${gradeMax}` }
}

const SectionCard = ({ summary, viewMode, gradeMax, onOpen }) => {
  const handleClick = useCallback(() => onOpen(summary.id), [onOpen, summary.id])
  const gaugeValue = gaugeValueFor(summary, viewMode, gradeMax)
  const { main, suffix } = valueParts(summary, viewMode, gradeMax)
  const showEmptyTooltip = viewMode === VIEW_MODES.GRADE && !summary.has_grade_questions

  return (
    <SectionGaugeCard
      emptyTooltip={EMPTY_TOOLTIP}
      gaugeValue={gaugeValue}
      main={main}
      name={summary.name}
      showEmptyTooltip={showEmptyTooltip}
      suffix={suffix}
      onClick={handleClick}
    />
  )
}

SectionCard.propTypes = {
  gradeMax: PropTypes.number.isRequired,
  onOpen: PropTypes.func.isRequired,
  summary: PropTypes.shape({
    grade: PropTypes.number,
    // eslint-disable-next-line camelcase
    has_grade_questions: PropTypes.bool,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    // eslint-disable-next-line camelcase
    satisfaction_rate: PropTypes.number
  }).isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)).isRequired
}

export default SectionCard
